import { NgModule } from '@angular/core';
import { MeSvgeditComponent } from './me-svgedit.component';

@NgModule({
  declarations: [
    MeSvgeditComponent
  ],
  imports: [
  ],
  exports: [
    MeSvgeditComponent,
  ]
})
export class MeSvgeditModule { }
